import { ReactElement } from 'react';
import { alpha, Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { Dialog, KnownDialogs, useDialog } from 'modules/dialogs/index';
import {
  globalTranslation,
  mergeTranslations,
  useTranslation,
} from 'modules/i18n';
import { SuccessIcon } from 'modules/icons';

import { ONE, ZERO } from '../../../common';
import { useGetStatsQuery } from '../../../dashboard/actions/getStats';
import { translation } from './translation';

const mergedTranslation = mergeTranslations(globalTranslation, translation);

const isSubtitleDisabled = true;

export function SuccessUnstakeDialog(): ReactElement {
  const {
    isOpened,
    onClose,
    amount = ZERO,
  } = useDialog(KnownDialogs.successUnstake);
  const { classes } = useStyles();
  const { t, keys } = useTranslation(mergedTranslation);

  const { data } = useGetStatsQuery();
  const rate = data?.rate ?? ONE;

  const stakedAmount = amount.div(rate);

  return (
    <Dialog open={isOpened} onClose={onClose}>
      <div className={classes.header}>
        <SuccessIcon />

        {t(keys.success)}
      </div>

      <div className={classes.description}>
        {t(keys.stakedValue, {
          value: amount.toFixed(4),
          stakedToken: t(keys.tokens.staked),
        })}

        {!isSubtitleDisabled && (
          <div className={classes.subtitle}>
            {t(keys.justSentValue, {
              value: stakedAmount.toFixed(4),
              nativeToken: t(keys.tokens.native),
            })}
          </div>
        )}
      </div>

      <Button className={classes.action} size="large" onClick={onClose}>
        {t(keys.close)}
      </Button>
    </Dialog>
  );
}

export const useStyles = makeStyles()(theme => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
    color: theme.palette.secondary.contrastText,
    fontSize: 24,
    fontWeight: 600,
  },
  description: {
    color: theme.palette.secondary.contrastText,
    marginTop: theme.spacing(2.5),
    fontSize: 16,
    fontWeight: 500,
  },
  action: {
    width: '100%',
    marginTop: theme.spacing(7),
  },
  subtitle: {
    color: alpha(theme.palette.secondary.contrastText, 0.6),
    marginTop: theme.spacing(1.5),
    fontSize: 16,
    fontWeight: 400,
  },
}));
